module.exports = __webpack_public_path__ + "static/media/dost_for_ever.0d7f46b5.png";